module.exports = __webpack_public_path__ + "static/media/caffe-milano-4.78abdb8d.jpg";